import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent } from '@material-ui/core';
import Typography, { fontStyle } from 'core/ui/Typography';
import SFDataTable from 'core/ui/DataTable';
import { currency, date } from 'core/utils/formatters';

const ModalPayments = ({ open, payments, close }) => {
  const columns = [
    {
      name: 'ID',
      selector: 'id',
      sortable: true,
      cell: (row) => <Typography style={fontStyle.small}>{row.id}</Typography>,
    },
    {
      name: 'Date',
      selector: 'id',
      sortable: true,
      cell: (row) => <Typography style={fontStyle.small}>{date(row?.createdAt)}</Typography>,
    },
    {
      name: 'Total Date Range',
      sortable: false,
      right: true,
      cell: (row) => <Typography style={fontStyle.small}>{currency(row?.amount)}</Typography>,
    },
  ];

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={() => close()}>
      <DialogContent>
        <SFDataTable columns={columns} data={payments} />
      </DialogContent>
    </Dialog>
  );
};

ModalPayments.defaultProps = {
  close: () => {},
};

export default ModalPayments;
